import React from "react";
import PropTypes from "prop-types";
import { TextareaField } from "evergreen-ui";
import { FastField, getIn } from "formik";

const FormTextarea = ({ name, onChange, ...rest }) => (
  <FastField name={name}>
    {({ field, form }) => {
      const error = getIn(form.errors, name);
      const handleChange = (e) => {
        field.onChange(e);
        onChange(e);
      };
      return (
        <TextareaField
          {...rest}
          {...field}
          autoComplete="off"
          isInvalid={!!error}
          onChange={handleChange}
          validationMessage={error}
        />
      );
    }}
  </FastField>
);

FormTextarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.number,
};

FormTextarea.defaultProps = {
  onChange: () => {},
  width: 240,
};

export default FormTextarea;
